/**
 * Tela "Integração via API" (Nuklie) liberada só para e-mails da lista, durante os testes em produção.
 * Configure com REACT_APP_PUBLIC_API_ALLOWED_EMAILS="a@x.com,b@y.com". Restrição só de interface: o backend não filtra por e-mail.
 * Use "*" para liberar a todos os usuários EMPRESA.
 */
const DEFAULT_ALLOWED_EMAILS = 'suporte@solarvision.app'

const allowedEmails = (process.env.REACT_APP_PUBLIC_API_ALLOWED_EMAILS || DEFAULT_ALLOWED_EMAILS)
  .split(',')
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean)

export const canAccessPublicApi = (user?: {email?: string; role?: {slug?: string}} | null) => {
  if (!user || user.role?.slug !== 'EMPRESA') return false
  if (allowedEmails.includes('*')) return true
  return allowedEmails.includes(String(user.email || '').trim().toLowerCase())
}
